import { FunctionsOutlined } from '@mui/icons-material'
import { useMediaQuery } from '@mui/material'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { fields } from 'src/components/utils/fields'
import { LoadingContext, M_Fieldset } from 'src/M_Components'

export const QuoteCalculator = ({ dataState, setDataState }) => {
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()

  const matches5 = useMediaQuery('(min-width:1420px)')
  const matches7 = useMediaQuery('(min-width:1280px)')
  const matches10 = useMediaQuery('(min-width:1150px)')
  const matches11 = useMediaQuery('(min-width:970px)')
  const matches14 = useMediaQuery('(min-width:870px)')
  const matches15 = useMediaQuery('(min-width:615px)')
  const matches16 = useMediaQuery('(min-width:440px)')

  const currencyOptions = [
    { label: '€', value: 'euro' },
    { label: '$', value: 'dollar' },
  ]

  const formFields = [
    { display: t('TotalCharges'), code: 'totalCharges' },
    { display: t('Currency'), code: 'totalCurrency' },
    { display: t('Markup'), code: 'totalMarkup' },
    { display: t('TotalCost'), code: 'totalCost' },
    { display: t('TotalSales'), code: 'totalSales' },
    { display: t('Profit'), code: 'totalProfit' },
  ]

  const getSum = (field) => {
    if (ctx.isLoad) return 0

    let sum = 0

    dataState?.charges?.forEach((charge) => {
      const quantity = (field === 'salesValue' && charge.multipleValue === 'Q') ? Number(charge['quantity']) || 1 : 1
      sum = sum + Number(charge[field]) * quantity
    })
    return sum || 0
  }

  const getProfit = () => {
    return (getSum('salesValue') - getSum('costValue')).toFixed(2)
  }

  const getMarkup = () => {
    return (
      ((getSum('salesValue') - getSum('costValue')) / getSum('costValue') ||
        0) * 100
    ).toFixed(2)
  }

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '25px',
              marginLeft: '10px',
            }}
          >
            <FunctionsOutlined style={{ marginRight: '10px', scale: '1.3' }} />{' '}
            {t('Totalizador')}
          </div>
        }
        elements={
          <div
            style={{
              display: 'grid',
              gridTemplateColumns:
                (!matches14 && 'auto') ||
                (!matches10 && 'auto auto') ||
                'auto auto auto',
              justifyContent: 'space-evenly',
              scale:
                (!matches15 && '.8') ||
                (!matches14 && '1') ||
                (!matches11 && '.9') ||
                (!matches10 && '1') ||
                (!matches7 && '.8') ||
                (!matches5 && '.9'),
            }}
          >
            {formFields.map((total, index) => (
              <M_Fieldset
                key={index}
                labelInside
                elements={
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: !matches16 && 'column ',
                      alignItems: 'center',
                      width: matches16 && '400px',
                    }}
                  >
                    <h2
                      style={{
                        color: 'var(--color-blue-dark)',
                        width: matches16 && '250px',
                        marginLeft: '5px',
                      }}
                    >
                      {total.display} :
                    </h2>
                    <h2
                      style={{
                        height: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        color:
                          total.code === 'totalProfit' && getProfit() > 0
                            ? 'var(--color-green-light)'
                            : total.code === 'totalProfit' && getProfit() < 0
                              ? 'var(--color-red)'
                              : null,
                      }}
                    >
                      {total.code === 'totalCharges' &&
                        dataState?.charges?.filter(
                          (obj) => obj?.serviceCode !== '',
                        ).length}
                      {total.code === 'totalCost' &&
                        `${getSum('costValue').toFixed(2)} ${dataState['totalCurrency']}`}
                      {total.code === 'totalCurrency' &&
                        fields(
                          {
                            display: '',
                            code: 'totalCurrency',
                            type: 'foreignKey',
                            entity: 'Currency',
                            filterField: 'code',
                            labelFields: ['Code'],
                            fields: [
                              { key: 'Code', value: 'totalCurrency' },
                              { key: 'Id', value: 'totalCurrencyId' },
                            ],
                          },
                          index,
                          dataState,
                          setDataState,
                          true,
                          null,
                          '150px',
                          currencyOptions,
                          0,
                        )}
                      {total.code === 'totalSales' &&
                        `${getSum('salesValue').toFixed(2)} ${dataState['totalCurrency']}`}
                      {total.code === 'totalMarkup' && `${getMarkup()} %`}
                      {total.code === 'totalProfit' &&
                        `${getProfit()} ${dataState['totalCurrency']}`}
                    </h2>
                  </div>
                }
              />
            ))}
          </div>
        }
      />
    </>
  )
}
